import { useEffect, useState } from 'react';
import api from '../../services/api';
import icone_administrativo from '../../assets/a.png';
import icone_servico from '../../assets/s.png';
import icone_vendas from '../../assets/v.png';
import icone_manutencaom from '../../assets/mm.png';
import icone_manutencaov from '../../assets/mv.png';
import PageContainer from '../../common/components/PageContainer';
import PageHeader from '../../common/components/PageHeader';
import EntityCardGrid from '../../common/components/EntityCardGrid';
import EntityCard from '../../common/components/EntityCard';

function Setor() {
  const [setores, setSetores] = useState([]);

  const icones = {
    administrativo: icone_administrativo,
    servico: icone_servico,
    vendas: icone_vendas,
    manutencaomecanica: icone_manutencaom,
    manutencaoveicular: icone_manutencaov,
  };

  const normalizeName = (name) => {
    return name
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/\s+/g, '');
  };

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await api.get('/setor');
        setSetores(response.data.content || response.data);
      } catch (error) {
        console.error('Erro ao buscar Setores:', error);
      }
    }
    fetchData();
  }, []);

  return (
    <PageContainer>
      <PageHeader title="Setor" />

      <EntityCardGrid
        items={setores}
        keyExtractor={(setor) => setor.id}
        emptyMessage="Nenhum setor encontrado."
        renderItem={(setor) => (
          <EntityCard
            to={`/setor/${setor.id}`}
            image={icones[normalizeName(setor.nome)]}
            title={setor.nome}
          />
        )}
      />
    </PageContainer>
  );
}

export default Setor;
